import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
//import {
//  Lists_dmcanbo
//} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { Ultil_donvi } from '../../../routes/menu';

 
const swal = require('sweetalert');
@Component({
    selector: 'app-quantri-donviedit',
  templateUrl: './donviedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./donviedit.component.scss'],
    providers: [ListService, Repository]
})
   

export class donvieditComponent implements OnInit {
  inputnoicaps: any;
  inputtinhs: any;
  inputxaphuongs: any;
  inputloais: any;
    @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
    @ViewChild('dteChung', { static: false }) doituongchungedit: any;
    @ViewChild('slTaiKhoanNH', { static: false }) slTaiKhoanNH: any;
  @ViewChild('inputTenKB', { static: false }) inputTenKB: any;

  @ViewChild('modalchondonvi', { static: false }) modalchondonvi: ModalComponent;
  @ViewChild('dtechondonvi', { static: false }) dtechondonvi: any;

  @ViewChild('modalchondonvibanle', { static: false }) modalchondonvibanle: ModalComponent;
  @ViewChild('dtechondonvibanle', { static: false }) dtechondonvibanle: any;
  @ViewChild('modalchontaikhoannganhang', { static: false }) modalchontaikhoannganhang: ModalComponent;
  @ViewChild('dtechontaikhoannganhang', { static: false }) dtechontaikhoannganhang: any;

  @ViewChild('modaldanhsachcapsogiayphep', { static: false }) modaldanhsachcapsogiayphep: ModalComponent;
  @ViewChild('dtedanhsachcapsogiayphep', { static: false }) dtedanhsachcapsogiayphep: any;
  @ViewChild('modaldanhsachnhanvien', { static: false }) modaldanhsachnhanvien: ModalComponent;
  @ViewChild('dtedanhsachnhanvien', { static: false }) dtedanhsachnhanvien: any;
  @ViewChild('modalchondonvicaptren', { static: false }) modalchondonvicaptren: ModalComponent;
  @ViewChild('dtechondonvicaptren', { static: false }) dtechondonvicaptren: any;

  @ViewChild('modalimport', { static: false }) modalimport: ModalComponent;
  @ViewChild('dtimportexcel', { static: false }) importedit: any;

  inputcapdonvis: any;
  inputvungmiens: any = [
    { Id: 0, Ten: "Miền Bắc" },
    { Id: 1, Ten: "Miền Trung" },
    { Id: 2, Ten: "Miền Nam" }
  ];
  datas: any;
  data2s: any;

  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TimKiem1s: any = {
    Don_Vi_Id: null
    , NhanSuId: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , BaoCaoId: null
  };
  public ngaytimkiem: Date = new Date();
  TichTatCa() {
    this.datas.forEach((item: any) => {
      item.Tich = !this.TatCa;
    });
  }
  onKeydownEvent1(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search();
    }
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.Loaddatas();
  }
  public onBlur(): void {
    this.Loaddatas();
  }
  search() {
    this.currentPage = 1;
    this.pageSize = 50;
    this.Loaddatas();
  }
  search1() {
    this.Loaddatas();
  }
  Loaddatas(): void {

    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    this.TimKiem1s.Don_Vi_Id = this.doituongSelect.Id;
    this.TimKiem1s.UserName = this.currentUser.user_name;
    this.TimKiem1s.Nam = this.currentUser.nam_ke_toan;
    this.TimKiem1s.startPage = this.StartPage;
    this.TimKiem1s.endPage = this.EndPage;
    if (this.ngaytimkiem != null) {
      this.TimKiem1s.ModifiedS = this.ngaytimkiem.getFullYear() + '-' + (this.ngaytimkiem.getMonth() + 1) + '-' + this.ngaytimkiem.getDate();
    }
    else
      this.TimKiem1s.ModifiedS = null;


    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiem1s)
    };
    //$('#loading').show();
    this.repo.postRequest("api/donvi/get_nhacungcap_listviewpage/", this.TimKiem1s)
      .subscribe(response => {
       // $('#loading').hide();
        this.totalPages = 0;
        this.totalItems = 0;
        if (response.length > 0) {

          this.tId = response[0].Id;
          this.TimKiem2s.DangKyId = response[0].Id;
          this.search2();
          
          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);

          let start, end;

          if (this.totalPages <= 5) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 4;
              end = this.totalPages;
            } else {
              start = this.currentPage - 2;
              end = this.currentPage + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.pages = resultArray;
        }
        this.datas = response;

        (window as any).timer4(0, 1500);

      });



  }

  tId: any;
  selectedRow: any;
  selected(row: any) {
    this.tId = row.Id;
    this.selectedRow = row;
    this.search2();
  }

  tId2: any;
  selectedRow2: any;
  selected2(row: any) {
    this.tId2 = row.Id;
    this.selectedRow2 = row;
  }
  

  public totalItem2s: number = 0;
  public currentPage2: number = 1;
  public maxSize2: number = 5;
  public TimKiem2: string;
  public StartPage2: number = 1;
  public EndPage2: number = 20;
  public pageSize2: number = 20;
  public page2s: any;
  public totalPage2s: number;
  public TimKiem2s: any = {
    Don_Vi_Id: null
    , NhanSuId: null
    , DangKyId: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , BaoCaoId: null
  };
  onKeydownEvent2(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search2();
    }
  }

  pageChanged2(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage2 = event.page;
    this.Loaddata2s();
  }
  setPage2(page: number): void {
    if (page < 1 || page > this.totalPage2s) {
      return;
    }

    this.currentPage2 = page;
    this.Loaddata2s();
  }
  public onBlur2(): void {
    this.Loaddata2s();
  }
  search2() {
    this.currentPage2 = 1;
    this.pageSize2 = 50;
    this.Loaddata2s();
  }
  search21() {
    this.Loaddata2s();
  }
  Loaddata2s(): void {
    this.data2s = [];
    this.StartPage2 = (this.currentPage2 - 1) * this.pageSize2 + 1;
    this.EndPage2 = this.currentPage2 * this.pageSize2;
    this.totalItem2s = 0;
    this.TimKiem2s.Don_Vi_Id = this.doituongSelect.Id;
    this.TimKiem2s.UserName = this.currentUser.user_name;
    this.TimKiem1s.DangKyId = this.tId;
    this.TimKiem2s.Nam = this.currentUser.nam_ke_toan;
    this.TimKiem2s.startPage = this.StartPage2;
    this.TimKiem2s.endPage = this.EndPage2;

    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiem2s)
    };
    //$('#loading').show();
    this.repo.postRequest("api/donvi/get_khachhang_listviewpage/", this.TimKiem2s)
      .subscribe(response => {
        //$('#loading').hide();
        this.totalPage2s = 0;
        this.totalItem2s = 0;
        if (response.length > 0) {

          var item = response[0];
          this.totalItem2s = item["totalRows"];
          this.totalPage2s = Math.ceil(this.totalItem2s / this.pageSize2);

          let start, end;

          if (this.totalPage2s <= 5) {
            start = 1;
            end = this.totalPage2s;
          } else {
            if (this.currentPage2 <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage2 + 1 >= this.totalPage2s) {
              start = this.totalPage2s - 4;
              end = this.totalPage2s;
            } else {
              start = this.currentPage2 - 2;
              end = this.currentPage2 + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.page2s = resultArray;
        }
        this.data2s = response;


        (window as any).timer5(0, 1500);

      });



  }



    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

    inputparents: any;
    inputnganhangs: any;
  currentUser: any;
  public changeTinh($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.Tinh = null;
      this.doituongSelect.Xa = null;
    }
    else {
      this.doituongSelect.Tinh = $event.Id;
      this.doituongSelect.Xa = null;
      this.repo.postRequest('api/donvibanle/getxaphuong', { UserName: this.currentUser.user_name, TinhId: this.doituongSelect.Tinh })
        .subscribe(response => {
          this.inputxaphuongs = response;
        });
    }
  }
  
    donviid: any;
    tabselected: number = 1;

    indLoading: boolean = false;    
    doituongSelect: any = {
    Id: null, Ma: null, Ten: null, DiaChi: null, DienThoai: null, Email: null,MaAo:null,
      CapTrenId: null, TenTiengNuocNgoai: null, SapXep: null
      , Created: null, CreatedBy: null, Modified: null, ModifiedBy: null
      , Ky_ThuTruongDonVi: null, Ky_KeToanTruong: null, Ky_ThuQuy: null, Ky_ThuKho: null, Ky_NguoiLapBaoCao: null
      , CapDonViId: null, TrangThai: null, VungMien: null
      , SoGiayPhep: null, NgayCap: null, NgayHetHan: null
      , NoiCapId: null, LoaiHinh: null, Tinh: null, Xa: null, DiaChiChiTiet: null
      , KinhDo: null, ViDo: null
    };    
    nhomdtid:string=null;


    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
      

    }
  comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV2(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }
  onDoiTuongChange($event) {

    if (typeof $event === "undefined") {
      this.doituongSelect.KBNN_Ten = null;
    }
    else
      this.doituongSelect.KBNN_Ten = $event.Ten_Doi_Tuong;
  }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        this.currentUser = JSON.parse(authlogin);
        this.donviid = this.currentUser.id_don_vi;
        var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].Them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].Sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].Xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
      }, 500);
      
      this.repo.postRequest("api/capdonvi/getall/", { Id: id, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputcapdonvis = response;
        });

      this.repo.postRequest("api/donvibanle/getnoicap/", { Id: id, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputnoicaps = response;
        });
      this.repo.postRequest("api/donvibanle/gettinh/", { Id: id, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputtinhs = response;
        });
      this.repo.postRequest("api/kybaocao/getloaihinhdoanhnghiep/", { UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputloais = response;
        });

     

      this.doituongSelect = {
        Id: null, Ma: null, Ten: null, DiaChi: null, DienThoai: null, Email: null, MaAo: null,
        CapTrenId: null, TenTiengNuocNgoai: null, SapXep: null
        , Created: null, CreatedBy: null, Modified: null, ModifiedBy: null
        , Ky_ThuTruongDonVi: null, Ky_KeToanTruong: null, Ky_ThuQuy: null, Ky_ThuKho: null, Ky_NguoiLapBaoCao: null
        , CapDonViId: null, TrangThai: true, VungMien: null
        , SoGiayPhep: null, NgayCap: null, NgayHetHan: null
        , NoiCapId: null, LoaiHinh: null, Tinh: null, Xa: null, DiaChiChiTiet: null
        , KinhDo: null, ViDo: null
      };

      this.repo.postRequest("api/donvi/getall3/", { Id: null, UserName: this.currentUser.user_name })
            .subscribe(response => {
              this.inputparents = response;
            });
        
        if(id === null)
        {
          this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
          //this.repo.postRequest("api/donvi/getall/", { Id: null, UserName: this.currentUser.user_name })
          //  .subscribe(response => {
          //    this.inputparents = response;
          //  });
        }
        else {
          //this.repo.postRequest("api/donvi/getall/", { Id: id, UserName: this.currentUser.user_name })
          //  .subscribe(response => {
          //    this.inputparents = response;
          //  });

            console.log(id);
            this.repo.getRequest("api/donvi/getbyid/" + id)
            .subscribe(response => {  
              console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.Ma = response.Ma;
              this.doituongSelect.Ten = response.Ten;
              this.doituongSelect.DiaChi = response.DiaChi;
              this.doituongSelect.DienThoai = response.DienThoai;
              this.doituongSelect.Email = response.Email;
              this.doituongSelect.MaAo = response.MaAo;
              this.doituongSelect.CapTrenId = response.CapTrenId;
              this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai;

              this.doituongSelect.Ky_ThuTruongDonVi = response.Ky_ThuTruongDonVi;
              this.doituongSelect.Ky_KeToanTruong = response.Ky_KeToanTruong;
              this.doituongSelect.Ky_ThuQuy = response.Ky_ThuQuy;
              this.doituongSelect.Ky_ThuKho = response.Ky_ThuKho;
              this.doituongSelect.Ky_NguoiLapBaoCao = response.Ky_NguoiLapBaoCao;

              this.doituongSelect.CapDonViId = response.CapDonViId;
              this.doituongSelect.TrangThai = response.TrangThai;
              this.doituongSelect.VungMien = response.VungMien;
              this.doituongSelect.SoGiayPhep = response.SoGiayPhep;
              if (response.NgayCap != null)
                this.doituongSelect.NgayCap = new Date(response.NgayCap);
              if (response.NgayHetHan != null)
                this.doituongSelect.NgayHetHan = new Date(response.NgayHetHan);

              this.doituongSelect.NoiCapId = response.NoiCapId;
              this.doituongSelect.LoaiHinh = response.LoaiHinh;
              this.doituongSelect.Tinh = response.Tinh;
              this.doituongSelect.Xa = response.Xa;
              this.doituongSelect.DiaChiChiTiet = response.DiaChiChiTiet;
              this.doituongSelect.KinhDo = response.KinhDo;
              this.doituongSelect.ViDo = response.ViDo;

              if (this.doituongSelect.Tinh != null) {
                this.repo.postRequest('api/donvibanle/getxaphuong', { UserName: this.currentUser.user_name, TinhId: this.doituongSelect.Tinh })
                  .subscribe(response => {
                    this.inputxaphuongs = response;
                  });
              }

              this.doituongSelect.SapXep = response.SapXep;
              this.doituongSelect.Created = response.Created;
              this.doituongSelect.CreatedBy = response.CreatedBy;
              this.doituongSelect.Modified = new Date();
              this.doituongSelect.ModifiedBy = this.currentUser.user_name;

              this.repo.postRequest("api/giayphep/getthongtindonviid/", { DonViId: this.doituongSelect.CapTrenId })
                .subscribe(response => {
                  if (response != null) {
                    this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai;
                  }
                });

              this.Loaddatas();
              this.Loaddata2s();
              
            }); 
        }
        
       
    }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {

    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }
   
  }
    keyTenPress(event: any) { 
        if (event.which === 13) {
          // this.slLoaiTaiSan.focus();
            event.preventDefault();
          }
  }
  keySoTKPress(event: any) {
    if (event.which === 13) {
       this.inputTenKB.focus();
      event.preventDefault();
    }
  }
  

  
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    if (this.doituongSelect.Ma == null || this.doituongSelect.Ma == "") {
      swal('Lỗi!', 'Vui lòng nhập mã đơn vị!.', 'error');
      return;
    }
    if (this.doituongSelect.Ten == null || this.doituongSelect.Ten == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đơn vị!.', 'error');
            return;
    }

    if (this.doituongSelect.CapDonViId == null) {
      swal('Lỗi!', 'Vui lòng nhập cấp đơn vị!.', 'error');
      return;
    }

    if (this.doituongSelect.Tinh == null) {
      swal('Lỗi!', 'Vui lòng nhập thông tin tỉnh!.', 'error');
      return;
    }

      
      
      this.repo.postRequest("api/donvi/addorupdate",this.doituongSelect)
        .subscribe(response => {
                    //if (response != null && response.match('-')) {
          if (response == 0 || (response != null && parseInt(response))) {
                      this.doituongSelect.Id = response;
                      this.save.emit(this.doituongSelect);
                    }
                    else {
                      swal('Lỗi!', response, 'error');
                    }
               
            }); 
    }
   
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent) {

    //this.comboSeleted = cobo;
    //cobo.close();
    //this.doituongchungedit.loadDataInit(Lists_dmcanbo.id, null, this.donviid);
    //this.mdDoiTuongChung.open();
  }
  saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();
    this.comboSeleted.focus();
  }
  deletedata_01(id: string) {
    swal({
      title: 'Bạn muốn xóa bản ghi?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.getRequest('api/donvi/delete_nhacungcap/' + id).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');
                this.Loaddatas();
              }
              else {
                // this.msg = data;
                alert(data);
              }
            }
          );
        }
      });


  }
  deletedata_02(id: string) {
    swal({
      title: 'Bạn muốn xóa bản ghi?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.getRequest('api/donvi/delete_khachhang/' + id).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');
                this.Loaddata2s();
              }
              else {
                // this.msg = data;
                alert(data);
              }
            }
          );
        }
      });


  }
  InputChange(row: any, loai: number) {
    if (loai == 0) {
      this.repo.postRequest("api/donvi/add_nhacungcap"
        , {
          Id: row.Id, DonViId: this.doituongSelect.Id, KhachHangNhaCungCapId: null
          , MaDonVi: row.MaDV, TenDonVi: row.TenDonVi, DiaChi: row.DiaChi, ThuocDonViId: row.ThuocDonViId
        }) 
        .subscribe(response => {
            
        });
    }
    else {
      this.repo.postRequest("api/donvi/add_khachhang"
        , {
          Id: row.Id, DonViId: this.doituongSelect.Id, KhachHangNhaCungCapId: null
          , MaDonVi: row.MaDV, TenDonVi: row.TenDonVi, DiaChi: row.DiaChi, ThuocDonViId: row.ThuocDonViId
        })
        .subscribe(response => {

        });
    }

  }
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  tieudedonvi: string;
  adddata_02() {
    this.tieudedonvi = "Danh sách đơn vị";
    if (this.doituongSelect.CapDonViId == 256 || this.doituongSelect.CapDonViId == 257) {
      this.tieudedonvi = "Danh sách đơn vị bán lẻ";
      this.dtechondonvibanle.loadDataInit(null, null, "03", 248, this.doituongSelect.Id);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.modalchondonvibanle.open();
    }
    else {
      let donvi = null;
      if (this.doituongSelect.CapDonViId == 234) {
        donvi = "235";
        this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 1);
        this.mBackdrop = setTimeout(() => {
          this.haveBackdrop();
        }, 500);
        this.modalchondonvi.open();
      }
      else if (this.doituongSelect.CapDonViId == 235) {
        donvi = '235,236,256,257';
        this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 1);
        this.mBackdrop = setTimeout(() => {
          this.haveBackdrop();
        }, 500);
        this.modalchondonvi.open();
      }
      else if (this.doituongSelect.CapDonViId == 236) {
        donvi = '236,256,257';
        this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 1);
        this.mBackdrop = setTimeout(() => {
          this.haveBackdrop();
        }, 500);
        this.modalchondonvi.open();
      }
      else {
        this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 1);
        this.mBackdrop = setTimeout(() => {
          this.haveBackdrop();
        }, 500);
        this.modalchondonvi.open();
      }
      

    }
  }



  adddata_01() {
    let donvi = null;
    if (this.doituongSelect.CapDonViId == 234) {
      donvi = "234";
      this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 0);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.modalchondonvi.open();
    }
    else if (this.doituongSelect.CapDonViId == 235) {
      donvi = "234,235";
      this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 0);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.modalchondonvi.open();
    }
    else if (this.doituongSelect.CapDonViId == 236) {
      donvi = "234,235,236";
      this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 0);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.modalchondonvi.open();
    }
    else if (this.doituongSelect.CapDonViId == 256 || this.doituongSelect.CapDonViId == 257) {
      donvi = "234,235,236";
      this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 0);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.modalchondonvi.open();
    }
    else if (this.doituongSelect.CapDonViId == 248) {
      donvi = "235,236";
      this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 2);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.modalchondonvi.open();
    }
    else {
      this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 0);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.modalchondonvi.open();
    }
  }
 

  saveModal_01(doituong: any) {
    this.modalchondonvi.dismiss();
    this.modalchondonvibanle.dismiss();
    this.Loaddatas();
    this.Loaddata2s();
  }
  adddata_tknh() {
    this.dtechontaikhoannganhang.loadDataInit(null, null, "03", this.doituongSelect.CapDonViId, this.doituongSelect.Id);
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
    }, 500);
    this.modalchontaikhoannganhang.open();
  }
  adddata_gp() {
    let noicapid = null;
    if (this.doituongSelect.Tinh != null)
      noicapid = this.doituongSelect.Tinh + 1;
    this.dtedanhsachcapsogiayphep.loadDataInit(null, null, "03", this.doituongSelect.CapDonViId, this.doituongSelect.Id, noicapid);
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
    }, 500);
    this.modaldanhsachcapsogiayphep.open();
  }
  adddata_nhanvien() {
    if (!this.dtedanhsachnhanvien || !this.modaldanhsachnhanvien) {
      swal('Lỗi!', 'Chưa sẵn sàng form nhân viên. Thử tải lại trang.', 'error');
      return;
    }
    this.modaldanhsachnhanvien.open();
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
      this.dtedanhsachnhanvien.loadDataInit(this.doituongSelect.Id, this.doituongSelect.Ten);
    }, 300);
  }
  saveModal_nhanvien(_doituong: any) {
    this.modaldanhsachnhanvien.dismiss();
  }
  saveModal_02(doituong: any) {
    this.modalchontaikhoannganhang.dismiss();
    this.modaldanhsachcapsogiayphep.dismiss();
  }

  adddatachondoituongchung(index: number) {
    let donvi = '234,235,236,256,257';
    this.dtechondonvicaptren.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 1);
    this.modalchondonvicaptren.open();
  }
  savedsdoituongchung(doituong: any) {
    let i = 0;
    if (doituong != null) {
      doituong.forEach(
        (item) => {
          if (i == 0) {
            this.repo.postRequest("api/giayphep/getthongtindonviid/", { DonViId: item.Id })
              .subscribe(response => {
                if (response != null) {
                  this.doituongSelect.CapTrenId = item.Id;
                  this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai;
                }
                this.modalchondonvicaptren.close();
              });
            
          }

        }
      );
    }
    else {
      this.doituongSelect.DonViId = null;
      this.doituongSelect.DonVi = null;
      this.modalchondonvicaptren.close();
    }
  }


  exportTableToExcel4(): void {
    const table = document.getElementById('fixTable4');
    if (!table) return;

    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const range = XLSX.utils.decode_range(worksheet['!ref']!);

    // --- Xác định cột tiền dựa vào header (dòng đầu) ---
    const moneyColumnIndexes: number[] = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCellRef = XLSX.utils.encode_cell({ r: 0, c: C });
      const headerCell = worksheet[headerCellRef];
      if (!headerCell || !headerCell.v) continue;

      const headerText = headerCell.v.toString().toLowerCase();
      // Nếu header chứa từ khóa "lớp", "tiền", "tổng", coi là cột số
      if (headerText.includes('đã thu') || headerText.includes('học phí')
        || headerText.includes('giảm giá') || headerText.includes('tiền')
        || headerText.includes('phải thu') || headerText.includes('được giảm')
        || headerText.includes('còn thiếu')
      ) {
        moneyColumnIndexes.push(C);
      }
    }

    const allRows = table.querySelectorAll('tr'); // NodeList tất cả <tr>
    // --- Duyệt các hàng, chỉ convert cột tiền ---
    for (let R = 1; R < allRows.length; ++R) { // bỏ header
      const row = allRows[R];
      const cells = row.querySelectorAll('td, th');

      for (const C of moneyColumnIndexes) {
        const cellElement = cells[C];
        if (!cellElement) continue;

        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];
        if (!cell || !cell.v) continue;

        const dataValue = cellElement.getAttribute('data-value');
        let val: number;
        if (dataValue) val = Number(dataValue);
        else val = Number(cell.v.toString().replace(/\./g, ''));

        cell.v = val;
        cell.t = 'n';
      }
    }

    // --- Tạo workbook và xuất file ---
    const workbook: XLSX.WorkBook = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    FileSaver.saveAs(data, 'exported-table.xlsx');
  }

  exportTableToExcel5(): void {
    const table = document.getElementById('fixTable5');
    if (!table) return;

    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const range = XLSX.utils.decode_range(worksheet['!ref']!);

    // --- Xác định cột tiền dựa vào header (dòng đầu) ---
    const moneyColumnIndexes: number[] = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCellRef = XLSX.utils.encode_cell({ r: 0, c: C });
      const headerCell = worksheet[headerCellRef];
      if (!headerCell || !headerCell.v) continue;

      const headerText = headerCell.v.toString().toLowerCase();
      // Nếu header chứa từ khóa "lớp", "tiền", "tổng", coi là cột số
      if (headerText.includes('đã thu') || headerText.includes('học phí')
        || headerText.includes('giảm giá') || headerText.includes('tiền')
        || headerText.includes('phải thu') || headerText.includes('được giảm')
        || headerText.includes('còn thiếu')
      ) {
        moneyColumnIndexes.push(C);
      }
    }

    const allRows = table.querySelectorAll('tr'); // NodeList tất cả <tr>
    // --- Duyệt các hàng, chỉ convert cột tiền ---
    for (let R = 1; R < allRows.length; ++R) { // bỏ header
      const row = allRows[R];
      const cells = row.querySelectorAll('td, th');

      for (const C of moneyColumnIndexes) {
        const cellElement = cells[C];
        if (!cellElement) continue;

        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];
        if (!cell || !cell.v) continue;

        const dataValue = cellElement.getAttribute('data-value');
        let val: number;
        if (dataValue) val = Number(dataValue);
        else val = Number(cell.v.toString().replace(/\./g, ''));

        cell.v = val;
        cell.t = 'n';
      }
    }

    // --- Tạo workbook và xuất file ---
    const workbook: XLSX.WorkBook = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    FileSaver.saveAs(data, 'exported-table.xlsx');
  }
   
  public importexcel() {
    let data = { id: Ultil_donvi.id, ThongKeId: Ultil_donvi.id, DonViId: this.doituongSelect.Id };
    this.importedit.loadDataInit(data); 
    this.modalimport.open();
  }
  saveModalImport(id: any) {
    console.log(id);
    this.Loaddata2s();
    this.modalimport.dismiss();
  }



}


